import * as React from 'react';
import { MessageBroker } from '~/Features/Messaging/MessageBroker';
import { Button } from '~/Partials/Button/Button';
import { ButtonSize } from '~/Partials/Button/ButtonSize.csharp';
import { ButtonType } from '~/Partials/Button/ButtonType.csharp';
import { TabSwitchRequested } from '~/Partials/TabsBar/Events/TabSwitchRequested';
import { TabSwitched } from '~/Partials/TabsBar/Events/TabSwitched';
import styles from './SwitchToTabButton.module.css';
import type { SwitchToTabButtonViewModel } from './SwitchToTabButtonViewModel.csharp';

export interface SwitchToTabButtonStateModel {
    visible: boolean;
}

export class SwitchToTabButton extends React.Component<SwitchToTabButtonViewModel, SwitchToTabButtonStateModel> {
    constructor(props: SwitchToTabButtonViewModel) {
        super(props);
        this.state = {
            visible: true,
        };
    }

    componentDidMount(): void {
        MessageBroker.subscribe(this, TabSwitched.id);
    }

    componentWillUnmount(): void {
        MessageBroker.unsubscribe(this, TabSwitched.id);
    }

    public scrollTo(scrollToElementById: string): void {
        const section = document.getElementById(scrollToElementById);

        if (!section) {
            return;
        }

        const header = document.getElementById('header');
        const headerOffset = (header && header.offsetHeight) || 0;
        const top = section.offsetTop + section.offsetHeight - headerOffset;

        if (top) {
            window.scroll({
                top,
                behavior: 'smooth',
            });
        }
    }

    public handle(event: TabSwitched): void {
        this.setState({
            visible: event.tabKey !== 'MoreStudyInfo',
        });
    }

    render() {
        const { text, buttonTier } = this.props;
        const { visible } = this.state;

        return (
            <>
                {visible && (
                    <Button
                        onClick={() => this.switchToTab()}
                        className={styles.SwitchToTabButton}
                        tier={buttonTier}
                        size={ButtonSize.Large}
                        type={ButtonType.Solid}
                    >
                        {text}
                    </Button>
                )}
            </>
        );
    }

    private switchToTab() {
        this.setState({ visible: false });
        const { tabKey, scrollToElementById } = this.props;
        MessageBroker.publish(new TabSwitchRequested(tabKey));
        this.scrollTo(scrollToElementById);
    }
}
